import { SVGProps, Ref, forwardRef } from 'react';

export const ChartBarOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.8 12c0-2.392.088-4.14.334-5.446.243-1.289.608-1.97 1.03-2.39.42-.422 1.101-.787 2.39-1.03C7.86 2.888 9.608 2.8 12 2.8s4.14.088 5.446.334c1.289.243 1.97.608 2.39 1.03.422.42.787 1.101 1.03 2.39.246 1.306.334 3.054.334 5.446s-.088 4.14-.334 5.446c-.243 1.289-.608 1.97-1.03 2.39-.42.422-1.101.787-2.39 1.03-1.306.246-3.054.334-5.446.334s-4.14-.088-5.446-.334c-1.289-.243-1.97-.608-2.39-1.03-.422-.42-.787-1.101-1.03-2.39C2.888 16.14 2.8 14.392 2.8 12M1 12C1 2.375 2.375 1 12 1s11 1.375 11 11-1.375 11-11 11S1 21.625 1 12m6.9 6v-6H6.1v6zm5 0h-1.8V6h1.8zm5 0v-8h-1.8v8z"
                fill="currentColor"
            />
        </g>
    </svg>
));
ChartBarOutlinedSize24Glyph.displayName = 'ChartBarOutlinedSize24Glyph';
